export default {
  slug: "startup-program",
  code: "ST",
  label: "Startup Program",
  logoFamily: "jb",
};
